import React from 'react';

// Utils
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';

// Components
import * as S from './Styled';
import cn from 'classnames';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.array.isRequired,
  ]),
};

const Badge = ({ children, tooltip, style, ...restProps }) => {
  let badgeClassName = Object.keys(restProps).length
    ? Object.keys(restProps)
    : '';

  return (
    <S.ExtBadge
      className={cn({
        [badgeClassName]: true,
        default: _isEmpty(restProps),
      })}
      style={style}
    >
      {children}
      {tooltip ? <S.Tooltip>{tooltip}</S.Tooltip> : null}
    </S.ExtBadge>
  );
};

Badge.propTypes = propTypes;

export default Badge;
